import React, { useEffect } from "react";
import refresh from "../../assets/img/icons/refresh.png";

const ReCaptcha = ({ captcha, reload }) => {
  useEffect(() => {
    if (captcha) {
      var canvas = document.getElementById("captch_canvas");
      var ctx = canvas.getContext("2d");
      ctx.save();
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      ctx.font = "30px cursive";
      ctx.fillStyle = "white";
      ctx.textAlign = "center";
      ctx.fillRect(0, 130, canvas.width, 70);
      ctx.fillText(captcha, canvas.width / 2, canvas.height / 1.5);
      ctx.restore();
    }
  }, [captcha]);
  return (
    <>
      <div>
        {/* <p className="sf_captcha">{captcha}</p> */}
        <canvas
          id="captch_canvas"
          width="180"
          height="40"
          // className="sf_captcha"
        ></canvas>
        <img src={refresh} className="captcha_reload" onClick={reload} />
      </div>
    </>
  );
};

export default ReCaptcha;
